
import Vue from 'vue'
import JcdcHeadline from '@/components/jcdc/JcdcHeadline.vue'
import JcdcBrandBar from '@/components/jcdc/JcdcBrandBar.vue'
import JcdcLabeledText from '@/components/jcdc/JcdcLabeledText.vue'
import { userInfo } from '@/util/navUtilities'
import { formatDisplayDateTime } from '@/util/formatters'
import {
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VDivider,
  VMain,
} from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcNetworkError',
  components: {
    JcdcHeadline,
    JcdcBrandBar,
    JcdcLabeledText,
    VCard,
    VCardText,
    VCardTitle,
    VContainer,
    VDivider,
    VMain,
  },
  props: {
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    appEnvironment: { type: String, default: 'production' },
    extHomeUrl: { type: String, default: undefined },
    customMessage: { type: String, default: '' },
    errorMessage: { type: [String, Object, Error], default: '' },
    userInfo: { type: Object as () => userInfo, default: undefined },
    tacContact: { type: Boolean, default: true },
  },
  computed: {
    errorDate(): Date {
      return this.errorMessage.response
        ? this.errorMessage.response.headers.date
        : formatDisplayDateTime(new Date())
    },
    errorUrl(): string {
      return this.errorMessage.response
        ? this.errorMessage.response.config.url
        : ''
    },
    errorStatus(): string {
      return this.errorMessage.response
        ? this.errorMessage.response.request.statusText
        : ''
    },
  },
  methods: {
    formatDisplayDateTime,
  },
})
